import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Title } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Button } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';
import { AccountsStore } from '../Accounts/AccountsStore';
import { AppStore } from '../Core/AppStore';
import { UserAccountsCard } from './UserAccountsCard';
import { UserAuditLog } from './UserAuditLog';
import { UserManageCard } from './UserManageCard';
import { UserRolesCard } from './UserRolesCard';
import { UsersStore } from './UsersStore';

export interface IUserEditParams {
    id: string;
}
export interface IUserEditProps extends RouteComponentProps<IUserEditParams> {}

@autoinject
@observer
export class UserEdit extends React.Component<IUserEditProps> {
    public async componentDidMount() {
        try {
            await this.usersStore.loadUserAsync(this.props.match.params.id);
            await this.accountsStore.loadAsync();
        } catch (e: any) {
            this.appStore.setError(e);
        }
    }

    public render() {
        return (
            <div className="container-fluid mt-5 pt-3">
                <Title>Edit {this.user?.userName ?? this.props.match.params.id}</Title>
                <div className="row">
                    <div className="col-md-6 col-xl-4">
                        <div className="row">
                            {this.user && (
                                <div className="col-12 mb-3">
                                    <UserRolesCard user={this.user} />
                                </div>
                            )}

                            {this.accountStore.isInRole('MriAdmin') && this.user && (
                                <div className="col-12 mb-3">
                                    <div className="card h-100">
                                        <div className="card-header bg-btn-primary">Impersonate</div>
                                        <div className="card-body text-center">
                                            <Button onClick={this.impersonateUser} color="primary">
                                                Impersonate User
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {this.user && (
                        <div className="col-md-6 col-xl-4 mb-3">
                            <UserAccountsCard user={this.user} />
                        </div>
                    )}

                    {this.user && this.accountStore.isInRoles(['MriAdmin', 'PortalAdmin']) && (
                        <div className="col-md-6 col-xl-4 mb-3">
                            <UserManageCard user={this.user} />
                        </div>
                    )}

                    {this.user && this.accountStore.isInRoles(['MriAdmin']) && (
                        <div className="col-12 mb-3">
                            <UserAuditLog user={this.user} />
                        </div>
                    )}
                </div>
            </div>
        );
    }

    @bind
    private async impersonateUser() {
        if (!this.user) {
            console.error('invalid user');
            return;
        }

        try {
            await this.accountStore.impersonateUserAsync(this.user);
        } catch (e: any) {
            console.error(e);
        }
    }

    @computed
    private get user() {
        return this.usersStore.users.get(this.props.match.params.id);
    }

    @inject
    private accountsStore!: AccountsStore;
    @inject
    private usersStore!: UsersStore;
    @inject
    private appStore!: AppStore;
    @inject
    private accountStore!: AccountStore;
}
